import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './App.scss';
import AppRoutes from './AppRoutes';
import Navbar from './shared/Navbar';
import Sidebar from './shared/Sidebar';
import Footer from './shared/Footer';
import axios from 'axios';

const baseUrl = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_BACKEND_LOCAL_API
  : process.env.REACT_APP_BACKEND_LIVE_API;

const ADMIN_THEME_KEY = 'admin_panel_theme';

class App extends Component {
  constructor(props) {
    super(props);
    let themeMode = 'light';
    try {
      const s = localStorage.getItem(ADMIN_THEME_KEY);
      if (s === 'dark' || s === 'light') themeMode = s;
    } catch (_) {}
    this.state = { themeMode, offcanvasOpen: false };
    this.applyAdminThemeToDocument(themeMode);
  }

  applyAdminThemeToDocument = (mode) => {
    const m = mode === 'dark' ? 'dark' : 'light';
    try {
      document.documentElement.setAttribute('data-admin-theme', m);
    } catch (_) {}
  };

  toggleTheme = () => {
    this.setState((prev) => {
      const next = prev.themeMode === 'light' ? 'dark' : 'light';
      try {
        localStorage.setItem(ADMIN_THEME_KEY, next);
      } catch (_) {}
      this.applyAdminThemeToDocument(next);
      return { themeMode: next };
    });
  };

  componentDidMount() {
    this.onRouteChanged();
    this._escHandler = (e) => {
      if (e.key === 'Escape' && this.state.offcanvasOpen) {
        this.closeOffcanvas();
      }
    };
    document.addEventListener('keydown', this._escHandler);
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(baseUrl + 'me', {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => {
        const data = res.data;
        try {
          if (data.user_type) localStorage.setItem('staff_user_type', data.user_type);
        } catch (_) {}
        if (data.user_type === 'Admin') {
          this.setState({
            usertype: 'Admin',
            userAname: data.Name,
            dashboard: true,
            earning: true,
            allAdmins: true,
            newAdmin: true,
            allUsers: true,
            sitesettings: true,
            newUser: true,
            pendingKyc: true,
            completedKyc: true,
            rejectKyc: true,
            allChallenges: true,
            completedChallenges: true,
            conflictChallenges: true,
            cancelledChallenges: true,
            runningChallenges: true,
            newChallenge: true,
            penaltyBonus: true,
            depositHistory: true,
            bonusHistory: true,
            withdrawlHistory: true,
            allWithdrawlRequests: true,
            allDepositRequests: true,
            pages: true,
            bonusReport: true,
            penaltyReport: true,
            withdrawalReport: true,
            depositReport: true,
            dropChallenges: true
          });
        } else if (data.user_type === 'Agent') {
          const perms = data.Permissions || [];
          const get = (i) => (perms[i] && perms[i].Status) || false;
          this.setState({
            usertype: 'Agent',
            userAname: data.Name,
            dashboard: get(0),
            earning: get(1),
            allAdmins: get(2),
            newAdmin: get(3),
            allUsers: get(4),
            newUser: get(5),
            pendingKyc: get(6),
            completedKyc: get(7),
            rejectKyc: get(8),
            allChallenges: get(9),
            completedChallenges: get(10),
            conflictChallenges: get(11),
            cancelledChallenges: get(12),
            runningChallenges: get(13),
            newChallenge: get(14),
            penaltyBonus: get(15),
            depositHistory: get(16),
            withdrawlHistory: get(17),
            allWithdrawlRequests: get(18),
            allDepositRequests: get(19),
            pages: get(20),
            bonusHistory: get(21),
            bonusReport: get(22),
            withdrawalReport: get(23),
            depositReport: get(24),
            penaltyReport: get(25),
            dropChallenges: get(26)
          });
        }
      }).catch(() => {});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  componentWillUnmount() {
    if (this._escHandler) {
      document.removeEventListener('keydown', this._escHandler);
    }
    document.body.classList.remove('admin-offcanvas-open');
  }

  openOffcanvas = () => {
    this.setState({ offcanvasOpen: true });
    document.body.classList.add('admin-offcanvas-open');
  };

  closeOffcanvas = () => {
    this.setState({ offcanvasOpen: false });
    document.body.classList.remove('admin-offcanvas-open');
  };

  toggleOffcanvas = () => {
    if (this.state.offcanvasOpen) {
      this.closeOffcanvas();
    } else {
      this.openOffcanvas();
    }
  };

  closeMobileSidebar = () => {
    this.closeOffcanvas();
  };

  onRouteChanged() {
    window.scrollTo(0, 0);
    this.closeOffcanvas();
    const fullPageLayoutRoutes = [
      '/user-pages/login-1', '/user-pages/login-2', '/user-pages/register-1', '/user-pages/register-2',
      '/user-pages/lockscreen', '/error-pages/error-404', '/error-pages/error-500', '/general-pages/landing-page',
      '/landing', '/login', '/register', '/adminlogin', '/home', '/profile', '/help', '/Deposit', '/',
      '/Homepage/pOPULAR', '/KYC/update-pan', '/KYC/update-aadhar', '/Games', '/Referral-history',
      '/wallet', '/support', '/Withdrawopt', '/Addcase', '/Addfunds', '/Notification', '/refer', '/transaction',
      '/transaction-history', '/web', '/return', '/redeem/refer', '/adminlogin'
    ];
    const path = this.props.location.pathname;
    const isFull = fullPageLayoutRoutes.some(r => path === r)
      || path.split('/')[1] === 'landing'
      || path.split('/')[1] === 'viewgame1';
    this.setState({ isFullPageLayout: isFull });
    const wrapper = document.querySelector('.page-body-wrapper');
    if (wrapper) {
      if (isFull) {
        wrapper.classList.add('full-page-wrapper');
      } else {
        wrapper.classList.remove('full-page-wrapper');
      }
    }
  }

  render() {
    const { isFullPageLayout, themeMode, offcanvasOpen } = this.state;
    const navbarComponent = !isFullPageLayout && (
      <Navbar
        usertype={this.state.usertype}
        userAname={this.state.userAname}
        themeMode={themeMode || 'light'}
        onToggleTheme={this.toggleTheme}
        onToggleNav={this.toggleOffcanvas}
      />
    );
    const sidebarComponent = !isFullPageLayout && (
      <Sidebar
        isOffcanvasOpen={offcanvasOpen}
        onNavigate={this.closeOffcanvas}
        themeMode={themeMode || 'light'}
        onToggleTheme={this.toggleTheme}
        usertype={this.state.usertype}
        dashboard={this.state.dashboard}
        earning={this.state.earning}
        allAdmins={this.state.allAdmins}
        newAdmin={this.state.newAdmin}
        sitesettings={this.state.sitesettings}
        allUsers={this.state.allUsers}
        newUser={this.state.newUser}
        pendingKyc={this.state.pendingKyc}
        completedKyc={this.state.completedKyc}
        rejectKyc={this.state.rejectKyc}
        allChallenges={this.state.allChallenges}
        completedChallenges={this.state.completedChallenges}
        conflictChallenges={this.state.conflictChallenges}
        cancelledChallenges={this.state.cancelledChallenges}
        runningChallenges={this.state.runningChallenges}
        newChallenge={this.state.newChallenge}
        penaltyBonus={this.state.penaltyBonus}
        depositHistory={this.state.depositHistory}
        bonusHistory={this.state.bonusHistory}
        withdrawlHistory={this.state.withdrawlHistory}
        allWithdrawlRequests={this.state.allWithdrawlRequests}
        allDepositRequests={this.state.allDepositRequests}
        pages={this.state.pages}
        bonusReport={this.state.bonusReport}
        penaltyReport={this.state.penaltyReport}
        withdrawalReport={this.state.withdrawalReport}
        depositReport={this.state.depositReport}
        dropChallenges={this.state.dropChallenges}
      />
    );
    const footerComponent = !isFullPageLayout && <Footer />;

    const tm = themeMode || 'light';
    const themeClass = !isFullPageLayout && tm === 'light' ? ' admin-theme-light' : '';

    return (
      <div
        className={`admin-app container-scroller admin-theme-v2 admin-shell-v3${isFullPageLayout ? ' admin-full-page' : ''}${themeClass}`}
      >
        {sidebarComponent}
        {!isFullPageLayout && (
          <div
            className={`admin-offcanvas-backdrop${offcanvasOpen ? ' is-visible' : ''}`}
            onClick={this.closeOffcanvas}
            onKeyDown={(e) => e.key === 'Escape' && this.closeOffcanvas()}
            role="presentation"
            aria-hidden={!offcanvasOpen}
          />
        )}
        {navbarComponent}
        <div className="container-fluid page-body-wrapper">
          <div className="main-panel">
            <div className="content-wrapper admin-content">
              <AppRoutes />
            </div>
            {footerComponent}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(App);
